import React, { Component } from "react";

export default class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { label, name, value, errors, onChange, placeholder, disabled, type } = this.props;
        return (
                <input
                    name={name}
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={onChange}
                />
        )
    }
}

